/* eslint react/no-danger: 0, react-hooks/exhaustive-deps: 0, jsx-a11y/anchor-is-valid: 0, react/no-array-index-key: 0 */
import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import Observer from 'react-intersection-observer';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import { GAfireEvent } from '../Tracking';
import 'react-app-polyfill/ie11';
import Button from '../Button';
import 'wicg-inert'
/* eslint-disable global-require */
import { isEs } from "../../libs/lang";
import { fireTag } from '../../libs/analytics';

const content = isEs() ? require('../../contentES').default.housing.featuredNew : require('../../content').default.housing.featuredNew;

const ReadWatch = ({item}) => (
	<button className={`read-watch ${isEs() ? 'es' : ''}`}
		type="button"
		onClick={() => {
			//fireTag("C2", `${item.hasOwnProperty('tag') ? item.tag.toLowerCase() : item.copy.toLowerCase()}`)
		}}
		tabIndex='-1'
		aria-label={`${item.copy} ${item.btn.copy}`}
	>
		{item.btn.copy}
	</button>

)

const StatItem = ({props, item, index, isRow, toggleShare, share, tileNumber}) => {
	const ariaText = isEs() ?

		`${tileNumber}, ${item.medium === 'article' ? 'Leer' : 'Ver'} el enlace - ${item.copy} ${item.timeAria || ''}- ${item.btn.copy.replace('min', 'minute')} - Un mosaico abre ${item.medium === 'article' ? 'un artículo' : 'un video'} - para activar, presionar “ingresar”`

		:

		`${tileNumber}, ${item.medium === 'article' ? 'Read' : 'Watch'} link - ${item.copy} ${item.timeAria || ''}- ${item.btn.copy.replace('min', 'minute')} - tile opens ${item.medium === 'article' ? 'an article' : 'a video'} - to activate press enter`;

	return (

		// eslint-disable-next-line jsx-a11y/no-static-element-interactions
		<a key={`stats__tile-${item.attrib.toLowerCase().replaceAll(' ', '-')}`} className={`tile ${item.medium}`}
			onClick={(event) => {
				//GAfireEvent(`isf_C17`, {label: `${item.btn.copy} ${item.copy}`});
				fireTag("C2", `${item.hasOwnProperty('tag') ? item.tag.toLowerCase() : item.copy.toLowerCase()}`)
				if (item.medium === 'article') {
					window.open(item.btn.href)
				}
				else if (item.medium === 'video') {

					if (item.video) {
						props.displayVideoOverlay(event);
					}
					else {
						window.open(item.btn.href)
					}
				}
			}}
			onKeyDown={event => {
				if (event.key === 'Enter') {
					toggleShare(!share);
					if (item.medium === 'article') {
						window.open(item.btn.href)
					}
					else if (item.medium === 'video') {
						if (item.video) {
							props.displayVideoOverlay(event);
						}
						else {
							window.open(item.btn.href)
						}
					}
				}
			}}
			data-video-type={item.medium === 'article' ? null : "vimeo"}
			data-videoid={item.video ? item.video.videoID : null} // vimeo
			/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */
			tabIndex='0'
			aria-label={`${ariaText}`}
		>
			<div className="stat-image--container">
				<div className={classNames('stat-image', item.attrib.toLowerCase().replaceAll(' ', '-'))} role="img" alt={item.alt}/>
			</div>

			<div className="stat-item">
				{item.title && (<h3>{item.title}</h3>)}
				<p id={`stat-copy-${index}`} dangerouslySetInnerHTML={{__html: item.copy}}/>
			</div>

			<ReadWatch item={item}/>


			{(item.timeAria) && (
				<p className="time">
					<time dateTime={item.time}>
						<span ref={node => node && node.setAttribute('inert', '')}>{item.time}</span>
					</time>
				</p>
			)}

		</a>
	)
}

const VisibleRow = ({visibleTilesNumber, totalTiles, toggleShare, share, tilesPerRow}) => {
	return (

		<>
			{
				(() => {
					const elements = [];
					for (let i = 0; i < totalTiles; i++) {

						elements.push(<StatItem
							item={content.tiles[i]}
							index={i + visibleTilesNumber}
							key={i}
							toggleShare={toggleShare}
							share={share}
							tileNumber={`${isEs() ? `${i + 1} de ${totalTiles} cuadros` : `${totalTiles} tiles`}`}
						/>);
					}
					return elements;
				})()


			}

		</>
	)
}


const FeaturedNew = props => {


	const [notInert, setnotdBeInert] = useState(true);
	const [share, toggleShare] = useState(false);
	const shareRef = useRef(null);

	const drawerConfigSettings = [
		{
			min: 0,
			max: 645,
			onload: 2,
			tilesPerRow: 2,
			noBlank: true,
		},
		{
			min: 646,
			max: 965,
			onload: 4,
			tilesPerRow: 2,
			noBlank: true,
		},
		{
			min: 966,
			max: 1279,
			onload: 3,
			tilesPerRow: 3,
			noBlank: false,
		},
		{
			// min: 1024,
			min: 1080,
			max: 1000000000,
			onload: 4,
			tilesPerRow: 4,
			noBlank: false,
		}
	]


	const drawerConfig = drawerConfigSettings.find(o => (window.innerWidth >= o.min && window.innerWidth <= o.max))
	const totalTiles = content.tiles.length;

	const visibleTilesNumber = drawerConfig.onload;
	const {tilesPerRow} = drawerConfig;


	function useOutsideAlerter(ref) {
		useEffect(() => {
			function handleClickOutside(event) {
				if (ref.current && !ref.current.contains(event.target)) {
					toggleShare(false);
				}
			}

			document.addEventListener("mousedown", handleClickOutside);

			window.setTimeout(function () {
				[...document.getElementsByClassName('splide__slide ')].forEach((slide) => {
					// console.log(slide);
					slide.tabIndex = 0;
					slide.setAttribute('aria-hidden', 'false');
				});
			}, 2000)

			return () => {
				document.removeEventListener("mousedown", handleClickOutside);
			};


		}, [ref]);
	}

	useOutsideAlerter(shareRef);

	let scrollFeatured = false;

	useEffect(() => {
		window.addEventListener('scroll',()=>{
			if(window.location.href.includes('/housing/') &&  !scrollFeatured && document.querySelector('#housing-featured-new').getBoundingClientRect().top <= document.querySelector('nav').getBoundingClientRect().height){
				scrollFeatured = true;
				fireTag('S2');
			}
		});
	},[])

	return (
		<>
			<Observer
				tag='section'
				id="housing-featured-new"
				threshold={0.50}
				triggerOnce
				onChange={inView => {
					if (inView) {
						//GAfireEvent('isf_S2');
					}
				}}
			>
				<h2 tabIndex="-1" dangerouslySetInnerHTML={{__html: content.headline}}/>
				<div className="stat-tiles">

					{/* Visible tiles go here. Only show the max number specified in the drawerConfig */}
					<VisibleRow visibleTilesNumber={visibleTilesNumber} totalTiles={totalTiles} tilesPerRow={tilesPerRow} toggleShare={toggleShare}/>

				</div>
			</Observer>
		</>
	);
}

export default FeaturedNew;
